import React, { useState, useEffect } from 'react';
import './HeroSection.css';
import image1 from '../assets/Deliverables/Others/6..png'
import image2 from '../assets/Deliverables/Others/7..png'
import image3 from '../assets/Deliverables/Others/11..png'

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
    {
      image: image1,
      // text: 'Hello',
    },
    {
      image: image2,
      // text: 'Hello',
    },
    {
      image: image3,
      // text: 'Hello',
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((currentSlide + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [currentSlide, slides.length]);

  return (
    <div className="hero-section">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
          style={{ backgroundImage: `url(${slide.image})` }}
        >
          <div className="hero-overlay">
            <div className="hero-content">
              <h1 className="hero-title">XANOMEGA</h1>
              <button className="hero-button">Explore</button>
            </div>
          </div>
        </div>
      ))}
      <div className="hero-indicators">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`indicator ${index === currentSlide ? 'active' : ''}`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroSection;